import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Bonus from './bonus'
import { formatWithCommas } from "../../helpers/common";


const Bonuses = ({ getBonusesDetails, contract }) => {
    const navigate = useNavigate();
    const [bonuses, setBonuses] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [selectedBonuses, setSelectedBonuses] = useState([]);
    useEffect(() => {

        getBonuses();

    }, []);

    useEffect(() => {

      console.log(selectedBonuses);

    }, [selectedBonuses]);
  
    const getBonuses = async () => {
        axios.get(process.env.REACT_APP_API_URL + "/get-bonuses", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                setBonuses(response?.data?.bonuses);
            })
            .catch(function (error) {
                if (error.status == 403) navigate("/login")
                else
                    Swal.fire({ icon: "error", title: "Error", text: error.message });

            });
    }

   

    const handleCheckboxChange = (id) => {
       
       // console.log(e.target.checked);
        if (selectedBonuses.indexOf(id) === -1) {
             setSelectedBonuses([...selectedBonuses,id]);
        } else {
          setSelectedBonuses(selectedBonuses.filter((s) => s != id));
        }
      };


    const removeBonuses = async (selected=0) => {

        let params = {};
        if(selected == 1){
            params = {
                bonus_ids : selectedBonuses,
            }
        }
        axios.post(process.env.REACT_APP_API_URL + "/remove-bonuses", params ,{
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                
                if (response?.data?.status) {
                    
                    setEditMode(false);
                    getBonuses();
                    setSelectedBonuses([]);

                }



            })
            .catch(function (error) {
                if (error.status == 403) navigate("/login")
                else
                    Swal.fire({ icon: "error", title: "Error", text: error.message });

            });
    }
    return (


        <div className="card" >

            <div className="card-title" >

                <div className="box-title color-white fs-18 fs-helvetica" >Bonuses</div>
                {bonuses && bonuses.length > 0  &&
                <>
                {editMode ?
                    <button className="btn btn-link fs-12" onClick={() => { setEditMode(false); setSelectedBonuses([]); }}  >Cancel</button>
                    :
                    <button className="btn btn-link fs-12" onClick={() => setEditMode(true)}  >Edit</button>
                }
                </>
                }
            </div>

            <div className="card-content" >

                {bonuses && bonuses.map((s, index) => {
                    return (
                        <div className={"list-layout "+ ((selectedBonuses.indexOf(s.bonus_id) !== -1) && "selected")}
                        onClick = {() => editMode && handleCheckboxChange(s.bonus_id)}
                        >
                            {editMode &&
                                <input name="bonuses[]" type="checkbox" className="chk chk-primary" 
                                value={s.bonus_id}
                                checked={(selectedBonuses.indexOf(s.bonus_id) !== -1)}
                               
                                 />
                            }
                            <label className="color-light fs-12  list-text">${formatWithCommas(s.bonus_amount)}</label>
                            <button className="btn btn-sm btn-secondary list-button ">{s.tag_title}</button>
                        </div>
                    )
                }
                )}

                {contract &&
                    <div className={"list-layout "+ (selectedBonuses?.length > 0 ? "justify-content-space-between":"justify-content-end" )  } >
                        <Bonus bonuses={bonuses} getBonusesDetails={getBonusesDetails} updateBonusList={getBonuses} selectedBonuses={selectedBonuses} editMode={editMode} removeBonuses={removeBonuses} />
                    </div>
                }



            </div>

        </div>






    );
};

export default Bonuses;